<template>
    <div>
        <v-dialog v-model="modale" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Modification du destinataire</span>
                </v-card-title>
                <v-card-text>
                    <v-combobox outlined label="E-mail" :items="contacts" clearable v-model="contact"
                        @input.native="updateSelectedContact" item-text="email" return-object>
                    </v-combobox>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="modale = false">Fermer</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="saveContact"
                            :disabled="modale === null">Enregistrer
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "UpdateReceiverModale",
    props: ['selectedContact', 'selectedProvider', 'editContactModal', 'noDb'],
    data() {
        return {
            modale: false,
            contact: null,
            provider: null
        }
    },
    methods: {
        updateSelectedContact(event) {
            this.contact = event.srcElement.value
        },
        saveContact() {
            if (this.noDb === undefined) {
                this.saveInDb()
            } else {
                this.saveNotInDb()
            }
        },
        saveInDb() {
            let email = (this.contact !== undefined &&
                this.contact !== null &&
                this.contact.email !== undefined) ? this.contact.email : this.contact

            let payload = {
                providerId: this.provider.id,
                email: email
            }

            this.$global.loading = true

            this.$http.post('auth/account/contact/update', payload).then(res => {
                let provider = res.body.data.provider

                this.$global.$emit('load-providers', provider)
                this.$global.$emit('reload-summary')

                this.contact = null
                this.provider = null
                this.modale = false

                this.$global.loading = false
            })
        },
        saveNotInDb() {
            let email = (this.contact !== undefined &&
                this.contact !== null &&
                this.contact.email !== undefined) ? this.contact.email : this.contact

            this.$global.$emit('update-email', email)

            this.modale = false
        }
    },
    watch: {
        editContactModal() {
            this.modale = this.editContactModal
            this.contact = this.selectedContact
            this.provider = this.selectedProvider
        },
        modale() {
            if (!this.modale) {
                this.$global.$emit('close-update-modal')
            }
        }
    },
    computed: {
        ...mapState('account', ['contacts'])
    }
}
</script>
